// src/app/routing/PrivateRoutes.tsx

import { Route, Routes, Navigate, Outlet, Link } from 'react-router-dom';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import CurriculumContext from '../contexts/CurriculumContext';
import UserRegistryContext from '../contexts/UserRegistryContext';
import VacancyContext from '../contexts/VacancyContext';
import { AdminAreaWrapper } from '../pages/admin/AdminAreaWrapper';
import { EmployerAreaWrapper } from '../pages/employer/EmployerAreaWrapper';
import { ProvisionalAreaWrapper } from '../pages/employer/ProvisionalAreaWrapper';
import { CounselorAreaWrapper } from '../pages/counselor/CounselorAreaWrapper';
import { EmployerMatchingCandidateWrapper } from '../pages/employer/EmployerMatchingCandidateWrapper';
import { CandidateAreaWrapper } from '../pages/candidate/CandidateAreaWrapper';
import { AdminCompanyManagementWrapper } from '../pages/admin/AdminCompanyManagementWrapper';
import { AdminRegistroManagementWrapper } from '../pages/admin/AdminRegistroManagementWrapper';
import { AdminEventosEmpleabilidadWrapper } from '../pages/admin/AdminEventosEmpleabilidadWrapper';
import { AdminEventoEmpleabilidadFormWrapper } from '../pages/admin/AdminEventoEmpleabilidadFormWrapper';
import { AdminEventoInformacionWrapper } from '../pages/admin/AdminEventoInformacionWrapper';
import { AdminEventoAsociacionVacantesWrapper } from '../pages/admin/AdminEventoAsociacionVacantesWrapper';
import { AdminEventoAsociacionOrientacionesWrapper } from '../pages/admin/AdminEventoAsociacionOrientacionesWrapper';
import { AdminEventoAsociacionFormacionesWrapper } from '../pages/admin/AdminEventoAsociacionFormacionesWrapper';
import { CandidateMatchingVacancyWrapper } from '../pages/candidate/CandidateMatchingVacancyWrapper';
import { CandidateRequestedVacancyWrapper } from '../pages/candidate/CandidateRequestedVacancyWrapper';
import { CandidateSearchVacantes } from '../pages/candidate/CandidateSearchVacantes';
import CustomCalendarComponent from '../components/CustomCalendar/Index';
import * as authHelper from '../modules/auth/core/AuthHelpers';
import { RoleEnum } from '../models/enums/RoleEnum';
import { AuthPage } from '../modules/auth';
import ResumeComponent from '../components/Resume/Index';
import ResumeCandidatoComponent from '../components/ResumeCandidato/Index';
import VacancyComponent from '../components/Vacancy/Index';
import { EmployerManagementVacancyWrapper } from '../pages/employer/EmployerManagementVacancyWrapper';
import { EmployerRequestedFeedbackCandidatoWrapper } from '../pages/employer/EmployerRequestedFeedbackCandidatoWrapper';
import { EmployerRequestedCandidatoVacancyWrapper } from '../pages/employer/EmployerRequestedCandidatoVacancyWrapper';
import { EmployerRequestedCandidatoPostularWrapper } from '../pages/employer/EmployerRequestedCandidatoPostularWrapper';
import { CandidatosManagementWrapper } from '../pages/counselor/CandidatosManagementWrapper';
import Profile from '../pages/profile/Profile';
import CompanyEditContext from '../contexts/CompanyEditContext';
import CompanyContext from '../contexts/CompanyContext';
import InformacionAdicionalVacancyContext from '../contexts/InformacionAdicionalVacancyContext';
import InformacionAdicionalEmpresaContext from '../contexts/InformacionAdicionalEmpresaContext';

import { UserJwtModel } from '../models/UserJwtModel';
import { RequireAuth } from '../modules/auth/RequireAuth';
import { PoliticasDashboardWrapper } from '../pages/dashboard/PoliticasDashboardWrapper';
import { EmpresasDashboardWrapper } from '../pages/dashboard/EmpresasDashboardWrapper';
import { CandidatosDashboardWrapper } from '../pages/dashboard/CandidatosDashboardWrapper';
import { EmployerFilesWrapper } from '../pages/employer/EmployerFilesManagementWrapper';
import BitacoraContext from '../contexts/BitacoraContext'
import { EmployerManagementBitacoraWrapper } from '../pages/employer/EmployerManagementBitacoraWrapper';
import { AssistedTrainingWrapper } from '../pages/counselor/AssistedTrainingWrapper';
import { CompanyAccompanimentWrapper } from '../pages/admin/CompanyAccompanimentWrapper';
import { AccompanyingBusinessForm } from '../modules/auth/components/AccompanyingBusinessForm';
import { AssistedCallRegistrationForm } from '../modules/auth/components/AssistedCallRegistrationForm';
import { RegisterParticipants } from '../pages/counselor/RegisterParticipants';
import { SeePaticipants } from '../pages/counselor/SeeParticipants';
import { ApproveParticipants } from '../pages/counselor/ApproveParticipants';
import { DownloadCertificates } from '../pages/counselor/DownloadCertificates';
import { AccompanimentToCandidates } from '../pages/counselor/AccompanimentToCandidates';
import { ManageAccompaniment } from '../modules/auth/components/ManageAccompaniment';
import { ListsOfValues } from '../pages/admin/ListsOfValues';
import { AddressOrientation } from '../pages/counselor/AddressOrientation';
import { RegisterAddressing } from '../pages/counselor/RegisterAddressing';
import { RegisterCounselors } from '../pages/counselor/RegisterCounselors';
import { UnemploymentRiskValues } from '../pages/counselor/UnemploymentRiskValues';
import { RecordingAndWeightingVariables } from '../pages/counselor/RecordingAndWeightingVariables';
import { TraceabilityOfCare } from '../pages/employer/TraceabilityOfCare';
import { DetailedReports } from '../pages/admin/DetailedReports';
import { AggregateReports } from '../pages/admin/AggregateReports';
import { ConsejeroCandidatoVacantesPostuladosWrapper } from '../pages/counselor/ConsejeroCandidatoVacantesPostuladosWrapper';
import { AdminCertificadoPlantillaWrapper } from '../pages/admin/CertificadoPlantillaPage';
import { AdminCertificadoPlantillaFormWrapper } from '../pages/admin/CertificadoPlantillaFormPage';
import { AdminCertificadoPlantillaPreviewWrapper } from '../pages/admin/CertificadoPlantillaPreviewPage';
import { CampusWrapper } from '../pages/campus/CampusWrapper';
import CampusStudentsPage from '../pages/campus/CampusStudentsPage';
import { CarguesMasivosWrapper } from '../pages/admin/CarguesMasivosWrapper';
import { MarcacionRemisionPotencialPage } from '../pages/admin/MarcacionRemisionPotencialPage';


type RequireAuthProps = {
	userRole: number,
	allowedRol: number
};

const PrivateRoutes = () => {

	const { user } = authHelper.getAuth() || {};
	const userJwt: UserJwtModel | undefined = authHelper.getAuthFromTokenJwt();
	const role = userJwt?.role;
	const hasCompany = user?.empresa_id ? true : false;

	const RoutesAdmin = ({ userRole, allowedRol }: RequireAuthProps) => {
		return (
			<Routes>
				<Route element={<RequireAuth userRole={userRole} allowedRol={allowedRol} />}>
					<Route element={<MasterLayout />}>
						{/* Solucion temporal al problema de clic en logos y redireccion a admin area cuando es se creo una empresa con rol administrador */}
						<Route path='auth/*' element={<Navigate to={hasCompany ? '/empleador/area' : '/admin/area'} />} />
						<Route path='admin/area' element={<AdminAreaWrapper />} />
						<Route path='admin/gestion-candidatos' element={<CandidatosManagementWrapper />} />
						<Route path='admin/Lista-de-valores' element={<ListsOfValues />} />
						<Route path='admin/gestion-empresas' element={<AdminCompanyManagementWrapper />} />
						<Route path='admin/gestion-registros' element={<AdminRegistroManagementWrapper />} />
						<Route path='admin/gestion-eventos' element={<AdminEventosEmpleabilidadWrapper />} />
						<Route path='admin/gestion-eventos/nuevo' element={<AdminEventoEmpleabilidadFormWrapper mode='create' />} />
						<Route path='admin/gestion-eventos/editar/:id' element={<AdminEventoEmpleabilidadFormWrapper mode='edit' />} />
						<Route path='admin/gestion-eventos/ver/:id' element={<AdminEventoEmpleabilidadFormWrapper mode='view' />} />
						<Route path='admin/gestion-eventos/informacion/:id' element={<AdminEventoInformacionWrapper />} />
						<Route path='admin/gestion-eventos/asociacion-vacantes/:id' element={<AdminEventoAsociacionVacantesWrapper />} />
						<Route path='admin/gestion-eventos/asociacion-orientaciones/:id' element={<AdminEventoAsociacionOrientacionesWrapper />} />
						<Route path='admin/gestion-eventos/asociacion-formaciones/:id' element={<AdminEventoAsociacionFormacionesWrapper />} />
						<Route path='admin/gestion-eventos/marcacion-remision/:id' element={<MarcacionRemisionPotencialPage />} />
						<Route path='admin/nuevo-usuario' element={<UserRegistryContext />} />
						<Route path='admin/editar-usuario/:id' element={<UserRegistryContext />} />
						<Route path='admin/registro-de-empresa' element={<CompanyContext />} />
						<Route path='admin/registro-de-empresa/:id' element={<CompanyEditContext />} />
						<Route path='admin/gestion-vacantes' element={<EmployerManagementVacancyWrapper />} />
						<Route path='admin/trazabilidad-de-atencion' element={<TraceabilityOfCare />} />
						<Route path='admin/gestion-de-vacante' element={<VacancyContext />} />
						<Route path='admin/gestion-de-vacante/:id' element={<VacancyContext />} />
						<Route path='admin/candidatos-postula/:id_vacante' element={<EmployerRequestedCandidatoPostularWrapper />} />
						<Route path='admin/hoja-vida/:id/:id_empresa/:id_vacancy' element={<ResumeComponent />} />
						<Route path='admin/matching-candidatos/:id' element={<EmployerMatchingCandidateWrapper />} />
						<Route path='admin/hoja-vida/:id' element={<ResumeComponent />} />
						<Route path='admin/crear-hoja-vida/:id' element={<CurriculumContext />} />
						<Route path='admin/reportes-agregados' element={<AggregateReports />} />
						<Route path='admin/reportes-detallados' element={<DetailedReports />} />
						<Route path='profile' element={<Profile />} />
						<Route path="*" element={<Navigate to="/" />} />
						<Route path='admin/dashboard/politicas' element={<PoliticasDashboardWrapper />} />
						<Route path='admin/dashboard/empresas' element={<EmpresasDashboardWrapper />} />
						<Route path='admin/dashboard/candidatos' element={<CandidatosDashboardWrapper />} />
						<Route path='admin/adicional-vacante/:id' element={<InformacionAdicionalVacancyContext />} />
						<Route path='admin/adicional-empresa/:id' element={<InformacionAdicionalEmpresaContext />} />
						<Route path='admin/empresa/:id_empresa/archivos' element={<EmployerFilesWrapper />} />
						<Route path='admin/gestion-bitacoras/:id_postulacion' element={<EmployerManagementBitacoraWrapper />} />
						<Route path='admin/bitacora/:id_postulacion/:id' element={<BitacoraContext />} />
						<Route path='admin/crear-acompanamiento-empresarial/:nitEmpresa/:idVacante/:nombreEmpresa/:nombreVacante' element={<AccompanyingBusinessForm />} />
						 {/* Plantillas de Certificados */}
						<Route path='admin/certificado-plantilla' element={<AdminCertificadoPlantillaWrapper />} />
						<Route path='admin/certificado-plantilla/crear' element={<AdminCertificadoPlantillaFormWrapper />} />
						<Route path='admin/certificado-plantilla/editar/:id' element={<AdminCertificadoPlantillaFormWrapper />} />
						<Route path='admin/certificado-plantilla/vista-previa/:id' element={<AdminCertificadoPlantillaPreviewWrapper />} />
						<Route path='admin/cargues-masivos' element={<CarguesMasivosWrapper />} />
						{/* Rutas de consejero para admin */}
						<Route path='consejero/direccionamiento-orientacion' element={<AddressOrientation />} />
						<Route path='consejero/direccionamiento-orientacion-gestion' element={<RegisterAddressing />} />
						<Route path='consejero/direccionamiento-orientacion-gestion/:id' element={<RegisterAddressing />} />
						<Route path='consejero/direccionamiento-orientacion-gestion/:id/:visible' element={<RegisterAddressing />} />
						<Route path='consejero/gestionar-orientados/:id/:subtipo' element={<RegisterCounselors />} />
						<Route path='consejero/gestionar-orientados/:id/:subtipo/:ver' element={<RegisterCounselors />} />
						<Route path='consejero/valores-de-riesgo-de-desempleo/:id' element={<UnemploymentRiskValues />} />
						<Route path='consejero/registro-y-ponderacion-de-variables/:id' element={<RecordingAndWeightingVariables />} />
						<Route path='consejero/acompanamiento-candidatos' element={<AccompanimentToCandidates />} />
						<Route path='consejero/gestionar-acompanamiento' element={<ManageAccompaniment />} />
						<Route path='consejero/gestionar-acompanamiento/:id' element={<ManageAccompaniment />} />
						<Route path='consejero/gestionar-acompanamiento/:idCandidato/:nombreCandidato' element={<ManageAccompaniment />} />
						<Route path='consejero/acompanamiento-empresarial' element={<CompanyAccompanimentWrapper />} />
						<Route path='consejero/registro-acompanamiento-empresarial' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/registro-acompanamiento-empresarial/:id' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/crear-acompanamiento-empresarial/:nitEmpresa' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/crear-acompanamiento-empresarial/:nitEmpresa/:idVacante/:nombreEmpresa/:nombreVacante' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/crear-acompanamiento-empresarial/:nitEmpresa/:idVacante' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/formacion-asistida' element={<AssistedTrainingWrapper />} />
						<Route path='admin/campus' element={<CampusWrapper />} />
						<Route path='admin/campus/participantes/:id' element={<CampusStudentsPage />} />
						<Route path='consejero/campus' element={<CampusWrapper />} />
						<Route path='consejero/campus/participantes/:id' element={<CampusStudentsPage />} />
						<Route path='consejero/registro-de-convocatorias-asistida' element={<AssistedCallRegistrationForm />} />
						<Route path='consejero/registro-de-convocatorias-asistida/:id' element={<AssistedCallRegistrationForm />} />
						<Route path='consejero/registro-de-convocatorias-asistida/:id/:visible' element={<AssistedCallRegistrationForm />} />
						<Route path='consejero/registrar_participantes/:id' element={<RegisterParticipants />} />
						<Route path='consejero/ver_asistentes/:id' element={<SeePaticipants />} />
						<Route path='consejero/aprobar_participantes/:id' element={<ApproveParticipants />} />
						<Route path='consejero/descargar_certificados_participantes/:id' element={<DownloadCertificates />} />
					</Route>
				</Route>
			</Routes>
		);
	};

	const RoutesCandidate = ({ userRole, allowedRol }: RequireAuthProps) => {
		return (
			<Routes>
				<Route element={<RequireAuth userRole={userRole} allowedRol={allowedRol} />}>
					<Route element={<MasterLayout />}>
						<Route path='auth/*' element={<Navigate to='/candidato/area' />} />
						<Route path='candidato/area' element={<CandidateAreaWrapper />} />
						<Route path='candidato/matching-vacantes' element={<CandidateMatchingVacancyWrapper />} />
						<Route path='candidato/search-vacantes' element={<CandidateSearchVacantes />} />
						<Route path='candidato/search-vacantes/:vacante' element={<CandidateSearchVacantes />} />
						<Route path='candidato/postuladas-vacantes' element={<CandidateRequestedVacancyWrapper />} />
						<Route path='candidato/crear-hoja-vida/:id' element={<CurriculumContext />} />
						<Route path='candidato/citas-programadas' element={<CustomCalendarComponent />} />
						<Route path='candidato/vacante/:id' element={<VacancyComponent />} />
						<Route path='candidato/gestion-eventos' element={<AdminEventosEmpleabilidadWrapper />} />
						<Route path='candidato/gestion-eventos/informacion/:id' element={<AdminEventoInformacionWrapper />} />
						<Route path='profile' element={<Profile />} />
						<Route path="*" element={<Navigate to="/" />} />
						<Route path='candidato/dashboard/candidato' element={<CandidatosDashboardWrapper />} />
					</Route>
				</Route>
			</Routes>
		);
	};

	const RoutesCounselorCandidate = ({ userRole, allowedRol }: RequireAuthProps) => {
		return (
			<Routes>
				<Route element={<RequireAuth userRole={userRole} allowedRol={allowedRol} />}>
					<Route element={<MasterLayout />}>
						<Route path='auth/*' element={<Navigate to='/consejero/area' />} />
						<Route path='consejero/area' element={<CounselorAreaWrapper />} />
						<Route path='consejero/nuevo-usuario' element={<UserRegistryContext />} />
						<Route path='consejero/registro-de-convocatorias-asistida' element={<AssistedCallRegistrationForm />} />
						<Route path='consejero/registro-de-convocatorias-asistida/:id' element={<AssistedCallRegistrationForm />} />
						<Route path='consejero/registro-de-convocatorias-asistida/:id/:visible' element={<AssistedCallRegistrationForm />} />
						<Route path='consejero/gestion-candidatos' element={<CandidatosManagementWrapper />} />
						<Route path='consejero/gestion-eventos' element={<AdminEventosEmpleabilidadWrapper />} />
						<Route path='consejero/gestion-eventos/informacion/:id' element={<AdminEventoInformacionWrapper />} />
						<Route path='consejero/formacion-asistida' element={<AssistedTrainingWrapper />} />
						<Route path='consejero/gestion-eventos/marcacion-remision/:id' element={<MarcacionRemisionPotencialPage />} />
						<Route path='consejero/campus/participantes/:id' element={<CampusStudentsPage />} />
						<Route path='consejero/campus' element={<CampusWrapper />} />
						<Route path='consejero/registrar_participantes/:id' element={<RegisterParticipants />} />
						<Route path='consejero/ver_asistentes/:id' element={<SeePaticipants />} />
						<Route path='consejero/aprobar_participantes/:id' element={<ApproveParticipants />} />
						<Route path='consejero/descargar_certificados_participantes/:id' element={<DownloadCertificates />} />
						<Route path='consejero/acompanamiento-candidatos' element={<AccompanimentToCandidates />} />
						<Route path='consejero/gestionar-acompanamiento' element={<ManageAccompaniment />} />
						<Route path='consejero/gestionar-acompanamiento/:id' element={<ManageAccompaniment />} />
						<Route path='consejero/gestionar-acompanamiento/:idCandidato/:nombreCandidato' element={<ManageAccompaniment />} />
						<Route path='consejero/search-vacantes/:id_candidato' element={<CandidateSearchVacantes />} />
						<Route path='consejero/vacante/:id/:id_candidato' element={<VacancyComponent />} />
						<Route path='consejero/candidatos-postula/:id_vacante' element={<EmployerRequestedCandidatoPostularWrapper />} />
						<Route path='consejero/hoja-vida/:id' element={<ResumeComponent />} />
						<Route path='consejero/crear-hoja-vida/:id' element={<CurriculumContext />} />
						<Route path='consejero/postuladas-vacantes/:id_candidato' element={<CandidateRequestedVacancyWrapper />} />
						<Route path='consejero/vacante/:id/:id_candidato' element={<VacancyComponent />} />
						<Route path='consejero/citas-programadas' element={<CustomCalendarComponent />} />
						<Route path='consejero/direccionamiento-orientacion' element={<AddressOrientation />} />
						<Route path='consejero/direccionamiento-orientacion-gestion' element={<RegisterAddressing />} />
						<Route path='consejero/direccionamiento-orientacion-gestion/:id' element={<RegisterAddressing />} />
						<Route path='consejero/direccionamiento-orientacion-gestion/:id/:visible' element={<RegisterAddressing />} />
						<Route path='consejero/gestionar-orientados/:id/:subtipo' element={<RegisterCounselors />} />
						<Route path='consejero/gestionar-orientados/:id/:subtipo/:ver' element={<RegisterCounselors />} />
						<Route path='consejero/valores-de-riesgo-de-desempleo/:id' element={<UnemploymentRiskValues />} />
						<Route path='consejero/registro-y-ponderacion-de-variables/:id' element={<RecordingAndWeightingVariables />} />
						<Route path='consejero/reportes-agregados' element={<AggregateReports />} />
						<Route path='consejero/reportes-detallados' element={<DetailedReports />} />
						<Route path='profile' element={<Profile />} />
						<Route path="*" element={<Navigate to="/" />} />
					</Route>
				</Route>
			</Routes>
		);
	};

	const RoutesCounselorEmployer = ({ userRole, allowedRol }: RequireAuthProps) => {
		return (
			<Routes>
				<Route element={<RequireAuth userRole={userRole} allowedRol={allowedRol} />}>
					<Route element={<MasterLayout />}>
						<Route path='auth/*' element={<Navigate to='/consejero/area' />} />
						<Route path='consejero/area' element={<CounselorAreaWrapper />} />
						<Route path='consejero/nuevo-usuario' element={<UserRegistryContext />} />
						<Route path='consejero/gestion-candidatos' element={<CandidatosManagementWrapper />} />
						<Route path='consejero/gestion-eventos' element={<AdminEventosEmpleabilidadWrapper />} />
						<Route path='consejero/gestion-eventos/informacion/:id' element={<AdminEventoInformacionWrapper />} />
						<Route path='candidato/vacante/:id' element={<VacancyComponent />} />
						<Route path='consejero/gestion-eventos/marcacion-remision/:id' element={<MarcacionRemisionPotencialPage />} />
						<Route path='consejero/search-vacantes/:id_candidato' element={<CandidateSearchVacantes />} />
						<Route path='consejero/adicional-vacante/:id' element={<InformacionAdicionalVacancyContext />} />
						<Route path='consejero/adicional-empresa/:id' element={<InformacionAdicionalEmpresaContext />} />
						<Route path='consejero/gestion-empresas' element={<AdminCompanyManagementWrapper />} />
						<Route path='consejero/gestion-vacantes-autopostuladas' element={<ConsejeroCandidatoVacantesPostuladosWrapper />} />
						<Route path='consejero/acompanamiento-empresarial' element={<CompanyAccompanimentWrapper />} />
						<Route path='consejero/registro-de-empresa' element={<CompanyContext />} />
						<Route path='consejero/registro-acompanamiento-empresarial' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/registro-acompanamiento-empresarial/:id' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/crear-acompanamiento-empresarial/:nitEmpresa' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/crear-acompanamiento-empresarial/:nitEmpresa/:idVacante/:nombreEmpresa/:nombreVacante' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/crear-acompanamiento-empresarial/:nitEmpresa/:idVacante' element={<AccompanyingBusinessForm />} />
						<Route path='consejero/registro-de-empresa/:id' element={<CompanyEditContext />} />
						<Route path='consejero/gestion-de-vacante' element={<VacancyContext />} />
						<Route path='consejero/gestion-vacantes' element={<EmployerManagementVacancyWrapper />} />
						<Route path='consejero/gestion-de-vacante/:id' element={<VacancyContext />} />
						<Route path='consejero/candidatos-postula/:id_vacante' element={<EmployerRequestedCandidatoPostularWrapper />} />
						<Route path='consejero/hoja-vida/:id/:id_empresa/:id_vacancy' element={<ResumeComponent />} />
						<Route path='consejero/matching-candidatos/:id' element={<EmployerMatchingCandidateWrapper />} />
						<Route path='consejero/hoja-vida/:id' element={<ResumeComponent />} />
						<Route path='consejero/empresa/:id_empresa/archivos' element={<EmployerFilesWrapper />} />
						<Route path='consejero/gestion-bitacoras/:id_postulacion' element={<EmployerManagementBitacoraWrapper />} />
						<Route path='consejero/reportes-agregados' element={<AggregateReports />} />
						<Route path='consejero/reportes-detallados' element={<DetailedReports />} />
						<Route path='profile' element={<Profile />} />
						<Route path="*" element={<Navigate to="/" />} />
						<Route path='consejero/bitacora/:id_postulacion/:id' element={<BitacoraContext />} />
						<Route path='consejero/campus' element={<CampusWrapper />} />
						<Route path='consejero/campus/participantes/:id' element={<CampusStudentsPage />} />
					</Route>
				</Route>
			</Routes>
		);
	};

	const RoutesEmployer = ({ userRole, allowedRol }: RequireAuthProps) => {
		return (
			<Routes>
				<Route element={<RequireAuth userRole={userRole} allowedRol={allowedRol} />}>
					<Route element={<MasterLayout />}>
						<Route path='auth/*' element={<Navigate to='/empleador/area' />} />
						<Route path='empleador/area' element={<EmployerAreaWrapper />} />
						<Route path='empleador/matching-candidatos' element={<EmployerMatchingCandidateWrapper />} />
						<Route path='empleador/matching-candidatos/:id' element={<EmployerMatchingCandidateWrapper />} />
						<Route path='empleador/gestion-vacantes-autopostuladas' element={<ConsejeroCandidatoVacantesPostuladosWrapper />} />
						<Route path='empleador/gestion-candidatos/:id_empresa' element={<EmployerRequestedCandidatoVacancyWrapper />} />
						<Route path='empleador/feedback-candidatos/:id_empresa' element={<EmployerRequestedFeedbackCandidatoWrapper />} />
						<Route path='empleador/candidatos-postula/:id_vacante' element={<EmployerRequestedCandidatoPostularWrapper />} />
						<Route path='empleador/gestion-vacantes' element={<EmployerManagementVacancyWrapper />} />
						<Route path='empleador/gestion-empresas' element={<AdminCompanyManagementWrapper />} />
						<Route path='empleador/registro-de-empresa/:id' element={<CompanyEditContext />} />
						<Route path='empleador/hoja-vida/:id/:id_empresa/:id_vacancy' element={<ResumeComponent />} />
						<Route path='empleador/hoja-vida/:id' element={<ResumeComponent />} />
						<Route path='empleador/entrevista/:id/:id_empresa/:id_vacancy' element={<ResumeCandidatoComponent />} />
						<Route path='empleador/gestion-de-vacante' element={<VacancyContext />} />
						<Route path='empleador/gestion-de-vacante/:id' element={<VacancyContext />} />
						<Route path='empleador/gestion-bitacoras/:id_postulacion' element={<EmployerManagementBitacoraWrapper />} />
						<Route path='empleador/gestion-eventos' element={<AdminEventosEmpleabilidadWrapper />} />
						<Route path='empleador/gestion-eventos/informacion/:id' element={<AdminEventoInformacionWrapper />} />
						<Route path='empleador/gestion-eventos/marcacion-remision/:id' element={<MarcacionRemisionPotencialPage />} />
						<Route path='profile' element={<Profile />} />
						<Route path="*" element={<Navigate to="/" />} />
						<Route path='empleador/dashboard/empresa' element={<EmpresasDashboardWrapper />} />
						<Route path='empleador/bitacora/:id_postulacion/:id' element={<BitacoraContext />} />
					</Route>
				</Route>
			</Routes>
		);
	};

	const RoutesProvisional = ({ userRole, allowedRol }: RequireAuthProps) => {
		return (
			<Routes>
				<Route element={<RequireAuth userRole={userRole} allowedRol={allowedRol} />}>
					<Route element={<MasterLayout />}>
						<Route path='auth/*' element={<Navigate to='/empleador/area' />} />
						<Route path='empleador/area' element={<ProvisionalAreaWrapper />} />
						<Route path='empleador/registro-de-empresa/:id' element={<CompanyEditContext />} />
						<Route path='profile' element={<Profile />} />
						<Route path="*" element={<Navigate to="/" />} />
					</Route>
				</Route>
			</Routes>
		);
	};

	const RoutesWithoutRole = () => {
		return (
			<Routes>
				<Route path='auth/*' element={<AuthPage />} />
			</Routes>
		);
	};

	const roleUser: number = role ?? -1;
	switch (roleUser) {
		case RoleEnum.ADMIN:
			return hasCompany ?
				<RoutesEmployer userRole={roleUser} allowedRol={RoleEnum.EMPLOYER} />
				: <RoutesAdmin userRole={roleUser} allowedRol={RoleEnum.ADMIN} />;
		case RoleEnum.CANDIDATE:
			return <RoutesCandidate userRole={roleUser} allowedRol={RoleEnum.CANDIDATE} />;
		case RoleEnum.COUNSELOR_CADIDATE:
			return <RoutesCounselorCandidate userRole={roleUser} allowedRol={RoleEnum.COUNSELOR_CADIDATE} />;
		case RoleEnum.COUNSELOR_EMPLOYER:
			return <RoutesCounselorEmployer userRole={roleUser} allowedRol={RoleEnum.COUNSELOR_EMPLOYER} />;
		case RoleEnum.EMPLOYER:
			return <RoutesEmployer userRole={roleUser} allowedRol={RoleEnum.EMPLOYER} />;
		case RoleEnum.PROVISIONAL:
			return <RoutesProvisional userRole={roleUser} allowedRol={RoleEnum.PROVISIONAL} />;
		default:
			return <RoutesWithoutRole />;
	}

};

export { PrivateRoutes };